<template>

    <div :class="[{ 'j-responsive-table' : responsive == true }]">
        <table :class="['j-table', $props.class]">

            <colgroup>
                <slot name="colgroup"></slot>
            </colgroup>

            <thead>
                <tr>
                    <slot name="head"></slot>
                </tr>
            </thead>

            <template v-if="isLoading">
                <TableRow v-for="i in skeletonRows">
                    <TableColumn v-for="i in skeletonColumns">
                        <Skeleton class="h-[30px]"></Skeleton>
                    </TableColumn>
                </TableRow>
            </template>

            <slot v-else name="body">
                <tbody :class="bodyClass">
                    <slot></slot>
                </tbody>
            </slot>

        </table>
    </div>

</template>

<script setup>
import { inject } from "vue";

import TableRow from "@/components/admin/TableRow.vue";
import TableColumn from "@/components/admin/TableColumn.vue";
import Skeleton from "@/components/admin/Skeleton.vue";

const props     = defineProps({

    class  : {
        type    : [ String, Array ],
        default : '',
    },

    bodyClass  : {
        type    : [ String, Array ],
        default : '',
    },

    responsive      : {
        type    : Boolean,
        default : true,
    },

    skeletonColumns     : {
        type    : Number,
        default : 0,
    },

    skeletonRows     : {
        type    : Number,
        default : 10,
    }
})

const isLoading     = inject("isLoading", false);
</script>